module.exports = __webpack_public_path__ + "static/media/set_protocol.a3a280e0.svg";